import { autoGrowDirective } from '@utils/directives';

export default ({ app }) => {
  app.use(autoGrowDirective);
};
